export default {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        level: 2,
      },
      content: [
        {
          text: '{{company.name}}',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      content: [
        {
          text: '{{company.addressLine1}}',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      content: [
        {
          text: '{{company.addressLine2}}',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      content: [
        {
          text: '{{company.phoneNumber}}',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
    },
    {
      type: 'table',
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Bill To',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'INVOICE #',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Name',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Address Line 1',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Address Line 2',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123-456-7890',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Service Date:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Invoice Date:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Due Date:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Amount Due: ',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        level: 3,
      },
      content: [
        {
          text: 'Service Items',
          type: 'text',
        },
      ],
    },
    {
      type: 'table',
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Service',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Quantity',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Rate',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Amount',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Add a photo or description',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '1',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '$100',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: null,
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '$100',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        level: 3,
      },
      content: [
        {
          text: 'TOTAL: $100',
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
    },
    {
      type: 'paragraph',
      content: [
        {
          text: 'Service Completed By:',
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        level: 3,
      },
      content: [
        {
          text: 'Completed Work',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      content: [
        {
          text: 'Use the link icon in the toolbar below to add a gallery link.',
          type: 'text',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        level: 3,
      },
      content: [
        {
          text: 'Payment From Client',
          type: 'text',
        },
      ],
    },
    {
      type: 'paragraph',
      content: [
        {
          text: 'Enter instructions here for client payment or add your Trusty payment link here.',
          type: 'text',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        level: 3,
      },
    },
    {
      type: 'paragraph',
    },
  ],
};
